/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createEntitlementsResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type EntitlementsResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/subscriptions/entitlements
 */
export interface EntitlementsRequestBuilder extends BaseRequestBuilder<EntitlementsRequestBuilder> {
    /**
     * Which products the organization's subscriptions entitle it to, read from billing price metadata, plus what adding the storefront would cost if it isn't already included.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<EntitlementsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<EntitlementsResponse | undefined>;
    /**
     * Which products the organization's subscriptions entitle it to, read from billing price metadata, plus what adding the storefront would cost if it isn't already included.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const EntitlementsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/subscriptions/entitlements";
/**
 * Metadata for all the requests in the request builder.
 */
export const EntitlementsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: EntitlementsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createEntitlementsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
